var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import padding from "@irati/ui/src/global/padding";
import { minWidthMedia } from "@irati/ui/src/global/media";
import { TROPHY_SIZE } from "../constants";
var ComponentToHideOnExpandContainer = styled("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  ", "\n"], ["\n  width: 100%;\n  ",
    "\n"])), minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: calc(100% - ", "px - ", ");\n    ", "\n  "], ["\n    width: calc(100% - ", "px - ", ");\n    ", "\n  "])), TROPHY_SIZE, padding.small, function (_a) {
    var isTrophySelected = _a.isTrophySelected;
    return isTrophySelected && "display: none;";
}));
export default ComponentToHideOnExpandContainer;
var templateObject_1, templateObject_2;
